module.exports = __webpack_public_path__ + "images/mobile/home/customer-logowall@2x-5f74668c0ed817c4b81a1626cfcb7fbb.png";